const gender = ["Male", "Female"];

export default gender